export type BioType = 'CRL' | 'BPD' | 'HC' | 'AC' | 'FL';

export const BIO_LIMITS: Record<BioType, { min: number, max: number, unit: string, full: string }> = {
    CRL: { min: 0, max: 100.0, unit: 'mm', full: 'Crown Rump Length' }, 
    BPD: { min: 2.0, max: 10.0, unit: 'cm', full: 'Bipar. Diameter' }, 
    HC: { min: 10.0, max:37.0, unit: 'cm', full: 'Head Circumference' },
    AC: { min: 10.0, max: 40.0, unit: 'cm', full: 'Abd. Circumference' },
    FL: { min: 1.0, max: 8.0, unit: 'cm', full: 'Femur Length' },
};

export const SWEEPS = [
  { id: 1, name: 'Sweep 1', animationClass: 'ultrasound-sweep-1' },
  { id: 2, name: 'Sweep 2', animationClass: 'ultrasound-sweep-2' }, 
  { id: 3, name: 'Sweep 3', animationClass: 'ultrasound-sweep-3' }, 
  { id: 4, name: 'Sweep 4', animationClass: 'ultrasound-sweep-4' }, 
  { id: 5, name: 'Sweep 5', animationClass: 'ultrasound-sweep-5' }, 
  { id: 6, name: 'Sweep 6', animationClass: 'ultrasound-sweep-6' }, 
  { id: 7, name: 'Sweep 7', animationClass: 'ultrasound-sweep-7' }, 
];